import classNames from "classnames";
import {Checkbox} from "@/shared/ui/Checkbox";
import {Radio} from "@/shared/ui/Radio";
import {FilterOption} from "../model/types";
import {CatalogFilterOptionLabel} from "./CatalogFilterOptionLabel";
import {useCatalogOptionsFilter} from "../model/useCatalogOptionsFilter";
import styles from "./CatalogOptionsFilter.module.scss";

type Props = {
    options: FilterOption[];
    visibleOptionsCount?: number;
    loading?: boolean;
    showAll?: boolean;
    onChange: (
        option: FilterOption
    ) => void;
    onShowAll?: () => void;
    insertColors?: Record<string, string>;
    className?: string;
    checkboxContainerClassName?: string;
    textPosition?: "left" | "right";
};

export const CatalogOptionsFilter = (
    {
        options,
        visibleOptionsCount = 8,
        loading = false,
        showAll = false,
        onChange,
        onShowAll,
        insertColors,
        className,
        checkboxContainerClassName,
        textPosition = "right",
    }: Props
) => {
    const preparedOptions = useCatalogOptionsFilter({options, visibleOptionsCount, showAll});

    return (
        <div className={classNames(styles.list, className, {[styles.loading]: loading})}>
            {preparedOptions.map((option) => {
                const commonProps = {
                    name: option.valueAlias,
                    value: option.valueAlias,
                    checked: Boolean(option.checked),
                    disabled: Boolean(option.disabled),
                    className: classNames(checkboxContainerClassName, {[styles.hidden]: option.hidden}),
                    onChange: () => onChange(option),
                    label: (<CatalogFilterOptionLabel option={option} insertColors={insertColors} />),
                    fullWidth: true,
                    textPosition,
                };

                if (option.type === "radio") {
                    return (<Radio key={option.id} {...commonProps} />);
                }

                return (<Checkbox key={option.id} {...commonProps} />);
            })}
            {!showAll && options.length > visibleOptionsCount && (
                <button type={`button`} className={styles.showAll} onClick={onShowAll}>
                    Посмотреть все
                </button>
            )}
        </div>
    );
};
